import { createContext } from "react";
import type { SearchTextContextType } from "../SearchTextProvider.types";

const SearchTextContext = createContext<SearchTextContextType | undefined>(undefined);
SearchTextContext.displayName = "SearchTextContext";

export default SearchTextContext;
